import SearchableSelect from "../ui/SearchableSelect";
import SwitchSelect from "../ui/SwitchSelect";
import "./LoonOpZandFilterBar.css";

export default function LoonOpZandFilterBar({
  issues,
  selectedIssues,
  onIssuesChange,
  questions,
  selectedQuestion,
  onQuestionChange,
  mode,
  onModeChange,
}) {
  const issueOptions = issues.map((issue) => ({
    value: issue.value,
    label: issue.label,
  }));

  return (
    <div className="loonopzand-filter-bar">
      <div className="loonopzand-filter-bar__questions">
        <SearchableSelect
          label="Vraag"
          name="loonopzand-question"
          value={selectedQuestion}
          options={questions}
          onChange={onQuestionChange}
          clearable={false}
        />
      </div>
      <div className="loonopzand-filter-bar__periods">
        <SearchableSelect
          label="Periode"
          name="loonopzand-issues"
          placeholder="Alle periodes"
          clearLabel="Alle periodes"
          value={selectedIssues}
          options={issueOptions}
          onChange={(selected) => onIssuesChange([...selected].sort())}
          multiple
        />
      </div>
      <div className="loonopzand-filter-bar__mode">
        <span className="loonopzand-filter-bar__label">Weergave</span>
        <SwitchSelect
          value={mode}
          onChange={onModeChange}
          options={["abs", "rel"]}
          labels={{ abs: "Absoluut", rel: "Percentage" }}
        />
      </div>
    </div>
  );
}
